import React, { useState } from 'react';

import ContactTfnEditDialog from '~/components/Finances/FinanceApprovalsTab/ContactTfnVerificationApprovals/ContactTfnEditDialog';
import { FinancesIcon } from '~/components/icons';
import InlineIconButton from '~/components/InlineIconButton';
import type { PageDataResponseTfnPendingVerificationItemNoneTypeTfnPendingVerificationItem } from '~/server_shared/openapi/data-contracts';

interface ContactTfnVerificationActionCellProps {
  row: PageDataResponseTfnPendingVerificationItemNoneTypeTfnPendingVerificationItem;
  onReload: () => void;
}

const ContactTfnVerificationActionCell: React.FC<ContactTfnVerificationActionCellProps> = ({ row, onReload }) => {
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);

  const handleClose = () => {
    onReload();
    setIsEditDialogOpen(false);
  };

  return (
    <div className="flex items-center justify-end gap-4">
      <InlineIconButton
        icon={FinancesIcon}
        onClick={() => setIsEditDialogOpen(true)}
        tooltipTitle="Contact TFN Details"
      />
      {isEditDialogOpen && (
        <ContactTfnEditDialog contactId={row.contact_id} onClose={handleClose} onSave={handleClose} />
      )}
    </div>
  );
};

export default ContactTfnVerificationActionCell;
